import React from 'react'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter as Router } from 'react-router-dom'

import { generateConfig } from '../config'
import { createNewStore } from '../store'

import { Routes } from '../routes/Routes'
import { useBuiltApolloClient } from '../routes/apollo'
import { ErrorBoundary } from '../errorsTracker'
import { StartABExperiments } from '../components/ABExperiments'
import { BoardingProvider } from '../providers/boardingProvider'
import { Provider as IntlProvider } from '../i18n'

export function App() {
  const apolloClient = useBuiltApolloClient()

  const store = React.useMemo(
    () => createNewStore({ ...generateConfig(), apolloClient }),
    [apolloClient]
  )

  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <IntlProvider>
          <StartABExperiments>
            <Provider store={store}>
              <BoardingProvider>
                <Router>
                  <Routes />
                </Router>
              </BoardingProvider>
            </Provider>
          </StartABExperiments>
        </IntlProvider>
      </ApolloProvider>
    </ErrorBoundary>
  )
}
